module.exports = __webpack_public_path__ + "static/img/head-bg.3c4c62f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/head-bg.png
// module id = YBov
// module chunks = 1